import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, Router } from '@angular/router';
import { RoleService } from 'ngx-core-services';
import { first } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class AtLeastInstallerGuard implements CanActivate {

  constructor(
    private readonly roleService: RoleService,
    private readonly router: Router,
  ) {}
  async canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ): Promise<boolean | UrlTree> {
    const has_somePermission = await this.roleService.has_somePermission$.pipe(
      first(),
    ).toPromise();

    if (has_somePermission) {
      return true;
    }
    return this.router.createUrlTree(['/']);
  }
}
